<template>
  <div :class="subNavOuterClasses">
    <div :class="subNavInnerClasses">

      <div class="sub-nav-head">
        <cvt-floating-breadcrumb
          :mode="'LIGHT'"
          :active-menu="activeMenu"
          :menus="breadcrumbMenus"
          :hide-back-btn="false"
          :hide-next-btn="false"
          @menuChanged="(eventData) => onBreadCrumbSelectionChange(eventData)"
        />
      </div>

      <div :class="subNavContentClasses">
        <slot></slot>
      </div>

    </div>
  </div>
</template>

<script>
import {  mapState } from 'vuex'
import { cvtRouteNodes } from "@/js/utils/routes"
export default {
  name: 'SubNavBar',
  props: {
    activeMenu: {
      type: String,
      default: 'design',
    },
  },
  data() {
    return {
      popupId: undefined,
      currentMenuId: this.activeMenu,
      breadcrumbMenus: [
        {
          id: 'design',
          routeNames: [cvtRouteNodes.design],
          title: 'Design',
          completed: false,
          disabled: false,
          action: this.designToggle,
        },
        {
          id: 'settings',
          routeNames: [cvtRouteNodes.settings],
          title: 'Settings',
          completed: false,
          disabled: false,
          action: this.settingToggle,
        },
        {
          id: 'publish',
          routeNames: [cvtRouteNodes.publish],
          title: 'Publish',
          completed: false,
          disabled: false,
          action: this.publishToggle,
        },
      ],
    }
  },

  computed: {
    ...mapState('globalTheme', {
      SideBarLeft: ({ globalTheme }) =>
        globalTheme.SideBarLeft !== undefined ? Boolean(globalTheme.SideBarLeft) : true,
    }),
    subNavOuterClasses() {
      return {
        'sub-nav-container': true,
        'design-page': this.currentMenuId === 'design',
        'settings-page': this.currentMenuId === 'settings',
        'publish-page': this.currentMenuId === 'publish',
      }
    },
    subNavInnerClasses() {
      return {
        'sub-nav': true,
        "left-sidebar":!!this.SideBarLeft,
        "right-sidebar":!this.SideBarLeft,
      }
    },
    subNavContentClasses() {
      return {
        'sub-nav-content': true,
        'design-page-2': this.currentMenuId === 'design',
        'settings-page-2': this.currentMenuId === 'settings',
      }
    },
  },
  mounted() {
    const { popupId } = this.$route.params
    this.popupId = popupId
  },
  methods: {
    designToggle() {
      this.$router.push({
        path: 'design',
      })
    },
    settingToggle() {
      this.$router.push({
        path: 'settings',
      })
    },
    publishToggle() {
      this.$router.push({
        path: 'publish',
      })
    },
    onBreadCrumbSelectionChange(eventData) {
      if (eventData && eventData.action) {
        eventData.action()
        this.currentMenuId = eventData.id
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import './styles/subNavBar.module.scss'
</style>
